import { render, staticRenderFns } from "./HeaderMentionsLegales.vue?vue&type=template&id=02b44e4d"
import script from "./HeaderMentionsLegales.vue?vue&type=script&lang=js"
export * from "./HeaderMentionsLegales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CampusDropDownMenuHeader: require('/home/apprentissage-montpellier/www/prod/AM-frontend/components/CampusDropDownMenuHeader.vue').default})
